import { LiabilityOwnershipMeta } from '/@/modules/liability/models/meta/LiabilityOwnershipMeta';

export class LoanAndCreditPaymentLiabilityMeta extends LiabilityOwnershipMeta {
  constructor(model = {}) {
    super(model);
  }
}
